import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import AccordionItem from "../components/elements/AccordionItem"
import Header from "../components/Header"

function FAQ() {
	const navigate = useNavigate()

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<>
			<div className="relative ">
				<picture>
					<source media="(min-width: 768px)" srcSet={"/images/promoSoonOverHeader.jpg"} />
					<img src={"/images/promoSoonOverHeader.jpg"} className=" block w-full" alt="Danke" />
				</picture>

				<h2 className="md:text-[70px] text-[25px]  absolute left-0 bottom-[40%] translate-y-1/2 w-full  text-center  ">
					FAQ
				</h2>
			</div>

			<div className="container mx-auto max-w-[800px] py-8 px-4   ">
				<h3 className="h3 text-black pb-6 text-left  mt-12">1. Allgemeine Informationen</h3>
				<AccordionItem headline="Wer ist der Veranstalter der Aktion?" num="1">
					<p>
						Veranstalter ist <br />
						<br />
						Wilkinson Sword GmbH
						<br />
						Schützenstraße 110
						<br />
						42659 Solingen
						<br />
						Deutschland
						<br />
						(im Folgenden „Veranstalter“ genannt)
						<br />
						<br />
						Die Aktion wird von der Magellan GmbH, Theo-Champion-Straße 2, 40549 Düsseldorf, Deutschland und
						der direct services Gütersloh GmbH, Reinhard-Mohn-Str. 300, 33333 Gütersloh, Deutschland
						durchgeführt.
					</p>
				</AccordionItem>
				<AccordionItem headline="Wer kann an der Aktion teilnehmen?" num="2">
					<>
						<p className="pb-6">
							Teilnehmen dürfen natürliche Personen ab 18 Jahren mit Wohnsitz in Deutschland, die
							unbeschränkt geschäftsfähig sind. Von der Teilnahme ausgeschlossen sind:
						</p>

						<ul className="pl-6 pb-6">
							<li className="list-disc">
								Mitarbeiter von Wilkinson Sword und der mit ihr verbundenen Unternehmen im Sinne von §
								15 AktG und deren Angehörige{" "}
							</li>
							<li className="list-disc">
								Mitarbeiter von Kooperationspartnern des Veranstalters, die an der Gestaltung oder
								Durchführung der Aktion beteiligt waren oder sind{" "}
							</li>
							<li className="list-disc">Alle Mitarbeiter der Dirk Rossmann GmbH</li>
						</ul>
						<p>
							Eine gewerbliche Teilnahme oder eine durch Dritte vermittelte Teilnahme (z.B.
							Gewinnspielservices, Makler oder Suchmaschinen) ist nicht zulässig. Außerdem behält sich der
							Veranstalter das Recht vor, Personen von der Teilnahme auszuschließen, bei denen der
							Verdacht besteht, dass sie sich bei der Teilnahme unerlaubter Hilfsmittel bedienen oder
							versuchen, sich oder Dritten durch Manipulation unfaire Vorteile zu verschaffen. Der
							Ausschluss kann in diesem Fall nach der Teilnahme erfolgen. Der Veranstalter hat das Recht
							die Gewinnausschüttung zu verweigern bzw. jeglichen Gewinn zurückzufordern.
						</p>
					</>
				</AccordionItem>

				<AccordionItem headline="Wie lange kann ich an der Aktion teilnehmen?" num="3">
					<p>
						Der Aktionszeitraum beginnt am 25.05.2026 und endet am 05.07.2026, 23:59 Uhr deutscher Zeit. Ein
						Teilnahmevorgang muss innerhalb dieses Zeitraums vollständig abgeschlossen werden, um als
						gültige Teilnahme akzeptiert zu werden. Über die erfolgreiche Teilnahme wird der Teilnehmer auf
						der Aktionsseite informiert.
					</p>
				</AccordionItem>
				<AccordionItem headline="Welche Produkte sind für die Teilnahme berechtigt?" num="4">
					<p className="pb-6">
						Die Aktion gilt für alle folgenden Produkte, die im Aktionszeitraum bei einem teilnehmenden
						Händler in Deutschland oder online innerhalb Deutschlands gekauft werden:
					</p>
					<ul className="pl-6 pb-6">
						<li className="list-disc">Bulldog Original Shampoo 300ml</li>
						<li className="list-disc">Bulldog Original 2in1 Bart & Gesichtsreiniger</li>
						<li className="list-disc">Bulldog Anytime Daily Feuchtigkeitscreme LSF 30 & 50, 75ml</li>
						<li className="list-disc">Bulldog Original Feuchtigkeitscreme</li>
						<li className="list-disc">Bulldog Duschgel - Zitrone & Bergamotte, 300ml</li>
						<li className="list-disc">Bulldog Duschgel - Original, 300ml</li>
						<li className="list-disc">
							Bulldog Sensitive Rasierer & Bulldog Sensitive 4er- und 8er Rasierklingen
						</li>
					</ul>
					<p className="pb-6">Teilnehmende Händler innerhalb Deutschlands:</p>
					<ul className="pl-6 ">
						<li className="list-disc">Dirk Rossmann GmbH</li>
					</ul>
				</AccordionItem>
				<AccordionItem headline="Wie oft kann eine Person teilnehmen?" num="5">
					<p>
						Pro Teilnehmer sind mehrere Teilnahmen an diesem Gewinnspiel möglich. Pro Teilnahme ist nur ein
						Kaufbeleg anwendbar und stellt somit nur eine Gewinnchance dar, auch wenn mehrere Produkte
						gekauft wurden. Die Teilnahme mittels automatisierter Datenverarbeitungsprozesse und/oder über
						die Einschaltung Dritter (z.B. von Gewinnspielagenturen) ist ausgeschlossen. Eine regelwidrige
						Teilnahme eines Teilnehmers an diesem Gewinnspiel hat seinen Spielausschluss zur Folge.
					</p>
				</AccordionItem>

				<h3 className="h3 text-black pb-6 text-left  mt-12">2. Durchführung und Abwicklung</h3>

				<AccordionItem headline="Wie kann ich an der Aktion teilnehmen?" num="6">
					<p className="pb-6">
						Um am Gewinnspiel teilzunehmen, muss der Teilnehmer im Zeitraum vom 25.05.2026 bis 05.07.2026 um
						23:59 Uhr ein Aktionsprodukt in der Filiale des teilnehmenden Händlers Rossmann oder über
						www.rossmann.de kaufen und den Kaufbeleg auf der Aktionswebsite
						https://de.bulldogskincare.com/pages/gewinnspiel-ironman-2026 hochladen. Hierbei ist zu
						beachten, dass der Scan oder das Foto des Original-Rechnungsbelegs folgende Punkte deutlich
						aufzeigt:
					</p>
					<ul className="pl-6 pb-6">
						<li className="list-disc">das teilnehmende Produkt</li>
						<li className="list-disc">das teilnehmende Geschäft</li>
						<li className="list-disc">den Preis</li>
						<li className="list-disc">die Rechnungsbelegnummer</li>
						<li className="list-disc">das Kaufdatum</li>
					</ul>
					<p className="pb-6">
						Der Veranstalter behält sich vor, den Originalkassenbon bis zum Ablauf der Aktion jederzeit für
						etwaige Nachprüfungen einzufordern.
					</p>
					<p>
						Die Gewinner werden innerhalb von zwei Wochen nach Aktionsende per Zufallsziehung aus allen
						gültigen Teilnahmen ermittelt. Die Gewinner werden per E-Mail informiert und müssen formlos (per
						E-Mail) die Gewinnannahme innerhalb von 14 Tagen bestätigen. Wenn ein Gewinner die Annahme des
						Gewinns nicht innerhalb von 14 Tagen bestätigt, verfällt der Gewinn, und ein anderer Gewinner
						wird nach dem Ermessen des Veranstalters aus dem ursprünglichen Pool der teilnahmeberechtigten
						Beiträge ausgewählt. Der Teilnehmer ist für die Richtigkeit der angegebenen Kontaktdaten
						verantwortlich. Kann der Gewinner aufgrund unvollständiger oder falscher Kontaktdaten nicht
						kontaktiert werden, verfällt der Gewinn, und ein anderer Gewinner wird gemäß den Bestimmungen
						dieser Klausel ausgewählt.
					</p>
				</AccordionItem>
				<AccordionItem headline="Welche Pflichtangaben müssen auf dem Kaufbeleg zu sehen sein?" num="7">
					<p>
						Auf dem Foto müssen alle relevanten Teile des Kassenbelegs gut sichtbar sein. Screenshots von
						digitalen Kaufbelegen sind möglich. Neben den Angaben, die als Teilnahmevoraussetzung
						erforderlich sind, müssen zusätzlich immer der Name des Händlers, der Kaufzeitpunkt (Datum und
						im Idealfall auch die Uhrzeit) und die Gesamtsumme des Kassenbelegs enthalten sein. Es ist nicht
						erlaubt denselben Kassenbeleg für mehrere Teilnahmen zu nutzen. Daten, die für die Teilnahme
						nicht erforderlich sind (z.B. sonstige gekaufte Produkte) können geschwärzt werden. Alle
						Kassenbelege werden automatisiert und nach Bedarf auch manuell überprüft. Bei Zweifel an der
						Echtheit des Belegs sowie bei nicht-lesbaren oder fehlenden Informationen ist eine Teilnahme
						ausgeschlossen.
					</p>
				</AccordionItem>
				<AccordionItem headline="Wie lädt man das Foto vom Kassenbon richtig hoch?" num="8">
					<p>
						Es können beim Upload nur Fotos im Format JPG, PNG und PDF und einer maximalen Größe von 8 MB
						pro Foto hochgeladen werden. Auf dem Kassenbon müssen die folgenden Daten erkennbar sein:
						Kaufdatum, Kaufpreis des Produktes, Bonsumme, Einkaufsstätte sowie das Produkt. Digitale
						Kassenbons (E-Bons) sind ebenfalls zulässig, sofern diese als einzelne Datei (als PDF oder PNG)
						oder Screenshot vorliegen, die alle vorgenannten Informationen aufweist. Auf dem Kassenbon
						abgebildete personenbezogene Daten (z. B. Namen von Beschäftigten) sind nicht abzulichten oder
						vorab zu schwärzen oder in sonstiger Weise unkenntlich zu machen. Unvollständige sowie
						verspätete Angaben können leider nicht berücksichtigt werden.
					</p>
					<p>Der Veranstalter behält sich vor, den Original-Kassenbon nachzufordern.</p>
				</AccordionItem>

				<h3 className="h3 text-black pb-6 text-left mt-12">3. Nach der Teilnahme</h3>

				<AccordionItem headline="Was kann ich Gewinnen?" num="9">
					<p className="pb-6">
						Im Aktionszeitraum 25.05.2026 - 05.07.2026 gibt es die Chance auf folgende Gewinnspielpreise:
					</p>
					<ul className="pl-6 pb-6">
						<li className="list-disc">1x Quintana Roo Service Course Road Bike</li>
						<li className="list-disc">
							10x Merch Pakete (bestehend aus einem Bulldog T-Shirt, ein Paar Bulldog-Socken und einem
							Bulldog-Bademantel)
						</li>
						<li className="list-disc">
							100x Bulldog Startersets (bestehend aus einem Original Rasierer, einer Original
							Feuchtigkeitscreme, einem Original Bartöl, einem Original 2in1 Bart & Gesichtsreiniger,
							einem Original Duschgel)
						</li>
						<li className="list-disc"> 500x 5€ Rossmann Gutscheine </li>
					</ul>

					<p className="pb-6">
						Die Vergabe der Preise findet nur unter den Teilnehmern statt, die sämtliche für die Teilnahme
						an dem Gewinnspiel auszufüllenden Eingabefelder vollständig, verständlich und richtig ausgefüllt
						haben.
					</p>
					<p>
						Ein Umtausch oder eine Barauszahlung der Gewinne ist nicht möglich. Der Gewinnanspruch ist nicht
						auf Dritte übertragbar.
					</p>
				</AccordionItem>
				<AccordionItem headline="Wann erhalte ich meinen Gewinn?" num="10">
					<p className="pb-6">
						Die Zustellung der Gewinne erfolgt per Paketdienst innerhalb von 4-6 Wochen nach Gewinnspielende
						an die vom Teilnehmer angegebene Adresse. Der Versand erfolgt nur innerhalb Deutschlands.
					</p>
					<p>
						Für den Fall, dass der Gewinn aus Gründen, die der Gewinner zu vertreten hat, nicht zugestellt
						werden kann (z. B. Angabe einer falschen Adresse), entfällt der Gewinnanspruch und der
						Veranstalter kann einen neuen Gewinner ermitteln.
					</p>
				</AccordionItem>

				<h3 className="h3 text-black pb-6 text-left mt-12">4. Sonstiges</h3>

				<AccordionItem headline="Kommen ggf. Kosten auf mich zu?" num="11">
					<p>
						Für die Teilnahme sind ein Internetzugang sowie der Kauf eines Aktionsprodukts im teilnehmenden
						Handel erforderlich. Die Gewinner tragen die Kosten für die Einsendung des originalen
						Rechnungsbelegs. Darüber hinaus entstehen keine weiteren Kosten.
					</p>
				</AccordionItem>
				<AccordionItem headline="Welche persönlichen Daten werden für die Teilnahme benötigt?" num="12">
					<p className="pb-6">
						Für die Teilnahme müssen die persönliche E-Mail-Adresse, der vollständige Name, die Anschrift
						sowie die Einkaufsstätte wahrheitsgemäß und vollständig angegeben werden. Diese Informationen
						werden benötigt, um die Aktion sicher abwickeln zu können.
					</p>
					<p>
						Personenbezogen Daten, die sich möglicherweise auf einem Kaufbeleg befinden und für Teilnahme am
						Gewinnspiel nicht erforderlich sind, sollten geschwärzt werden (z.B. Adressdaten).
					</p>
				</AccordionItem>
				<AccordionItem headline="Wird der Original-Rechnungsbeleg benötigt?" num="13">
					<p>
						Der Veranstalter behält sich vor, den Originalkassenbon bis zum Ablauf der Aktion jederzeit für
						etwaige Nachprüfungen sowie nach Ablauf der Aktion zur Gewinneinlösung einzufordern. Wenn
						gefordert, muss der Teilnehmer den Kassenbon an den Veranstalter bzw. an die Magellan GmbH
						senden.
					</p>
				</AccordionItem>
				<AccordionItem headline="Wie werden Daten im Rahmen der Aktion verarbeitet?" num="14">
					<p className="pb-6">
						Für die Abwicklung der Aktion ist es notwendig, dass personenbezogen Daten verarbeitet werden
						(z.B. E-Mail-Adresse, Name und Anschrift). Diese Daten werden vom Veranstalter und
						Dienstleistern des Veranstalters mit äußerster Sorgfalt und gemäß den gültigen
						Datenschutzbestimmungen verarbeitet. Details sind in der Datenschutzerklärung beschrieben.
					</p>
					<p className="pb-6">
						Alle Teilnahmedaten werden für die gesamte Dauer der Aktion gespeichert und spätestens 6 Wochen
						nach Ende der Aktion gelöscht, sofern keine besondere Einwilligung in eine längerfristige
						Speicherung erfolgte oder eine längerfristige Speicherung aus rechtlichen Gründen erforderlich
						ist. Eine längerfristige Speicherung erfolgt beispielsweise, falls die freiwillige Einwilligung
						für den Empfang eines Newsletters gegeben wurde. Dabei werden nur die tatsächlich benötigten
						Daten gespeichert. Alle nicht benötigten Daten werden auch in diesen Fällen gelöscht.
					</p>
					<p>
						Darüber hinaus können statistische Daten gespeichert werden (z.B. für Nutzungsstatistiken).
						Statistische Daten werden nur in vollständig anonymisierter Form verarbeitet. Ein Rückschluss
						auf einzelne Personen ist dabei ausgeschlossen.
					</p>
				</AccordionItem>
				<AccordionItem headline="Werden Daten von teilnehmenden Personen veröffentlicht?" num="15">
					<p>
						Der Veranstalter wird ohne Erlaubnis grundsätzlich keine Daten von teilnehmenden Personen
						veröffentlichen. Nur nach ausdrücklicher, vorheriger Einwilligung der teilnehmen Personen ist es
						möglich, dass beispielsweise die Gewinnernamen auf einer Website oder in einem Social Media Post
						genannt werden. Auf Wunsch erfolgt die Nennung dabei in anonymisierter Form.{" "}
					</p>
				</AccordionItem>
				<AccordionItem headline="Du hast keine Antwort auf deine Frage erhalten?" num="16">
					<p>
						Das Service-Team ist per E-Mail unter{" "}
						<a href="mailto:bulldog@gewinnspiel-2026.de" className="underline">
							bulldog@gewinnspiel-2026.de
						</a>{" "}
						erreichbar.{" "}
					</p>
				</AccordionItem>
			</div>
			<div className="py-10 pt-5 text-center">
				<button onClick={() => navigate(-1)} className="btn btn-green">
					Zurück
				</button>
			</div>
		</>
	)
}
export default FAQ
